import './App.css';
import React, { createContext, useState, useEffect } from 'react';
// import 'mdb-ui-kit/css/mdb.min.css';

import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from 'react-alert-template-basic';

import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Skill from './components/Skill';
import Qualification from './components/Qualification';
import Service from './components/Service';
import Portfolio from './components/Portfolio';
import Project from './components/Project';
import Testimonial from './components/Testimonial';
import Contact from './components/Contact';
import ScrollBtn from './components/ScrollBtn';
import Footer from './components/Footer';


function App() {

  const toggleTheme = (event) => {
    if (event.target.checked === true) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');  
    }
  }

  const options = {
    timeout: 2000,
    position: positions.MIDDLE,
    transition: transitions.FADE
  };
  
  return (
    <AlertProvider template={AlertTemplate} {...options}>
      <div className="App main">
        <Navbar toggleTheme={toggleTheme}/>
        <Home/>
        <About/>
        <Skill/>
        <Qualification/>
        <Service/>
        <Portfolio/>
        <Project/>
        <Testimonial/>
        <Contact/>
        <Footer/>
        <ScrollBtn/>
      </div>
    </AlertProvider>
  );
}

export default App;
